import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  credentialChecklist,
  credentialChecklistByID,
} from "../../../api/resignationCheckliistAssign";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";

export default function CredentialsForm({
  reportingManager,
  foundStatus,
  lastStatus,
  locationemployeeId,
  latestStatus,
}) {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [credRemarks, setCredRemarks] = useState("");
  const [others, setOthers] = useState("");
  const [credData, setCredData] = useState([]);
  const [listData, setListData] = useState({
    system_credentials: "",
    db_credentials: "",
    server_credentials: "",
    github_credentials_revoke: "",
    developer_credentials_revoke: "",
    code_access_revoke: "",
    reporting_manager_remarks: "",
    others: "",
  });
  const [inputsDisabled, setInputsDisabled] = useState(false);
  const EmpId = localStorage.getItem("EmpId");
  const ReportingManager = localStorage.getItem("ReportingManager");
  const dispatch = useDispatch();
  const [useLocationEmpId, setUseLocationId] = useState("");

  const labelMapping = {
    system_credentials: "System Credentials",
    db_credentials: "DB Credentials",
    server_credentials: "Server Credentials Revoke",
    github_credentials_revoke: "Github Credentials Revoke",
    developer_credentials_revoke: "Developer Credentials Revoke",
    code_access_revoke: "Code Access Revoke",
    reporting_manager_remarks: "Reporting Manager Remarks",
    others: "Others",
  };

  useEffect(() => {
    if (
      params.status === "CREDENTIALS_CHECKLIST_APPROVED" ||
      params.status === "KT_APPROVED"
    ) {
      if (locationemployeeId === "" || locationemployeeId === undefined) {
        navigate("/resignation-request");
      } else {
        setUseLocationId(locationemployeeId);
        ktChecklistApproveById();
      }
    }
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();

    // Validation for radio buttons
    const radioKeys = [
      "system_credentials",
      "db_credentials",
      "github_credentials_revoke",
      "developer_credentials_revoke",
      "code_access_revoke",
    ];
    for (let key of radioKeys) {
      if (!listData[key]) {
        dispatch(showAlert(`Please select ${labelMapping[key]}`));
        return;
      }
    }

    // Validation for text fields
    if (!listData.reporting_manager_remarks) {
      dispatch(showAlert(`Please provide Reporting Manager Remarks`));
      return;
    }

    let FormData = {
      ...listData,
      emp_id: useLocationEmpId.toString() || EmpId.toString(),
      reporting_manager: reportingManager || ReportingManager,
    };
    try {
      const { data } = await credentialChecklist(FormData, user.token);
      dispatch(showAlert(data.msg));
      navigate("/resignation-request");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  async function ktChecklistApproveById() {
    try {
      const { data } = await credentialChecklistByID(
        locationemployeeId,
        user.token
      );
      if (data?.data?.length) {
        const credData = data.data[0];
        const { id, emp_id, reporting_manager, created_on, ...filteredData } =
          credData;
        const processedData = {
          ...filteredData,
          github_credentials_revoke: credData.github_credentials_revoke
            ? "yes"
            : "no",
          developer_credentials_revoke: credData.developer_credentials_revoke
            ? "yes"
            : "no",
          code_access_revoke: credData.code_access_revoke ? "yes" : "no",
        };
        setListData({
          ...processedData,
          reporting_manager_remarks: credData.reporting_manager_remarks || "",
          others: credData.others || "",
        });
        setInputsDisabled(true);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onFormChange = (event) => {
    setListData({
      ...listData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        {Object.entries(listData).map(([key, value]) => {
          if (key !== "reporting_manager_remarks" && key !== "others") {
            return (
              <Grid item xs={12} key={key}>
                <FormControl>
                  <Typography variant="subtitle1">
                    {labelMapping[key]}
                  </Typography>
                  <RadioGroup
                    row
                    aria-label={labelMapping[key]}
                    name={key}
                    value={value}
                    onChange={onFormChange}
                    disabled={inputsDisabled}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                    {["system_credentials", "db_credentials"].includes(key) && (
                      <FormControlLabel
                        value="null"
                        control={<Radio />}
                        label="NA"
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            );
          }
          return null;
        })}
        <Grid item xs={6}>
          <TextField
            rows={3}
            label={labelMapping["reporting_manager_remarks"]}
            name="reporting_manager_remarks"
            value={listData.reporting_manager_remarks}
            onChange={onFormChange}
            fullWidth
            multiline
            disabled={inputsDisabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            rows={3}
            fullWidth
            label={labelMapping["others"]}
            name="others"
            value={listData.others}
            onChange={onFormChange}
            multiline
            disabled={inputsDisabled}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            columnGap: 1,
            mt: 1,
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            CANCEL
          </Button>
          {latestStatus === "KT_APPROVED" && (
            <Button
              variant="contained"
              onClick={onSubmit}
              style={{ padding: "5px 7px" }}
              className="blue-button"
              disabled={inputsDisabled}
            >
              SUBMIT
            </Button>
          )}
        </Box>
      </Grid>
    </Paper>
  );
}
